import { Action } from 'redux'
import { ICreateReservationFormValues } from '../../../containers/Form/CreateReservation/CreateReservation'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'
import { IEvent } from '../../../models/Event'

const requestCreateEvent = (
  event: ICreateReservationFormValues,
  formName: string,
): IRequestCreateEvent => ({
  event,
  formName,
  type: EventActions.RequestCreateEvent,
})

export interface IRequestCreateEvent
  extends Action<EventActions.RequestCreateEvent> {
  event: ICreateReservationFormValues
  formName: string
}

const eventWasCreated = (event: IEvent): IEventWasCreated => ({
  event,
  type: EventActions.EventWasCreated,
})

export interface IEventWasCreated extends Action<EventActions.EventWasCreated> {
  event: IEvent
}

const createBulkEvents = (events: IEvent[]): IEventsBulkCreated => ({
  events,
  type: EventActions.EventsBulkCreated,
})

export interface IEventsBulkCreated
  extends Action<EventActions.EventsBulkCreated> {
  events: IEvent[]
}

export { eventWasCreated, createBulkEvents }
export default requestCreateEvent
